"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Aside/components/DBlock.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    Extension_template = require("../../../../components/Extension/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Extension_tag = marko_loadTag(Extension_template),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value");

function render(input, out, __component, component, state) {
  var data = input;

  const { id, options } = input

  const { name, ...rest } = Object.assign( options, { id } )

  out.be("div", {
      style: marko_styleValue("z-index:" + options.zindex),
      "class": "position-absolute top-0 w-100 vh-100 theme-bg"
    }, "@" + ("Block-" + id), component, null, 1);

  Extension_tag(marko_assign({
      name: name
    }, rest), out, __component, (id + "-") + random(1, 3000), [
    [
      "quit",
      () => GState.extension.close( id ),
      false
    ]
  ]);

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
